export const ADDRESS_ICONS = {
  imgCake: '2XYvmP5nRevM62fGkKLV0w',
  imgMelocoton: 'WBDdGI3DkGd9QCGHjM5Di'
}
